var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 32,
    viewBox: "0 0 177 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H9.04751C15.8514 0 21.0743 4.63459 21.0743 12.8733C21.0743 21.1121 15.8514 25.7467 9.04751 25.7467H0V0ZM9.04751 24.0914C14.5652 24.0914 19.0146 20.2668 19.0146 12.8733C19.0146 5.47991 14.564 1.69184 9.04751 1.6553H1.9123V24.0914H9.04751Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7188 15.6328C23.7188 9.01283 28.0951 5.18701 33.5019 5.18701C38.9088 5.18701 43.2851 9.01162 43.2851 15.6328C43.2851 22.254 38.9088 26.0786 33.5019 26.0786C28.0951 26.0786 23.7188 22.254 23.7188 15.6328ZM41.3363 15.6328C41.3363 10.0421 37.9161 6.80577 33.5019 6.76923C29.0878 6.73269 25.6676 10.0421 25.6676 15.6328C25.6676 21.2236 29.0878 24.5342 33.5019 24.4976C37.9161 24.4599 41.3363 21.2236 41.3363 15.6328Z",
    fill: "#101828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9766 15.5963C45.9766 9.45376 49.6172 5.18701 55.7598 5.18701C61.3505 5.18701 64.4029 8.82891 64.845 13.2418H62.8962C62.6392 9.78506 60.1373 6.76801 55.761 6.76801C50.9059 6.76801 47.9266 10.4099 47.9266 15.5951C47.9266 21.075 51.3468 24.4964 55.761 24.4964C60.1751 24.4964 62.4918 21.1493 62.8962 18.427H64.845C64.3298 22.4367 61.1666 26.0774 55.7598 26.0774C49.912 26.0774 45.9766 21.9215 45.9766 15.5951V15.5963Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7164 18.5006C87.7164 23.0244 83.8918 25.7467 79.1829 25.7467H68.6641V0H78.742C82.5301 0 85.8772 2.39099 85.8772 6.58344C85.8772 9.23143 84.1854 11.1803 81.6848 11.9903C85.2158 12.6529 87.7164 14.933 87.7164 18.5006ZM70.5764 1.6553V11.3289H77.8955C81.4265 11.3289 83.8175 9.56395 83.8175 6.58466C83.8175 3.60536 81.5739 1.6553 78.2999 1.6553H70.5764ZM85.6568 18.5006C85.6568 15.0804 82.8614 12.983 78.6312 12.983H70.5764V24.0914H78.7786C82.714 24.0914 85.6568 21.7369 85.6568 18.5006Z",
    fill: "#101828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.494 24.2026V25.7471H108.097C106.221 25.7471 105.081 24.607 105.081 22.6569V20.3768C104.125 23.9809 100.998 26.1137 97.2464 26.1137C93.311 26.1137 90.5156 23.8335 90.5156 19.9346C90.5156 16.3305 92.8701 13.8299 97.8348 13.8299H100.483C103.683 13.8299 104.859 12.8737 104.859 11.0711C104.859 8.38652 102.652 6.76777 99.4158 6.76777C95.9578 6.76777 93.5302 8.60699 93.2002 12.0637H91.2879C91.6557 7.64962 94.7458 5.18555 99.417 5.18555C104.088 5.18555 106.81 7.72392 106.81 11.4754V22.4365C106.81 23.5765 107.289 24.2014 108.355 24.2014H109.495L109.494 24.2026ZM104.97 13.205H104.933C104.418 14.6387 102.947 15.4486 100.299 15.4486H97.9078C93.8993 15.4486 92.501 17.7666 92.501 19.9359C92.501 22.2538 94.0089 24.4974 97.5034 24.4974C101.182 24.4974 104.97 22.0333 104.97 16.3317V13.205Z",
    fill: "#101828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.118 5.51733L116.187 30.9704C115.93 31.5953 115.341 31.9997 114.532 31.9997H108.242V30.4552H114.494L116.774 24.644L109.197 5.51855H111.22L117.694 22.5478L124.094 5.51855H126.117L126.118 5.51733Z",
    fill: "#101828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.137 17.0003V5.80029H158.305V10.9043H164.401V5.80029H165.569V17.0003H164.401V11.9283H158.305V17.0003H157.137Z",
    fill: "#101828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.672 14.6803L176.312 17.0003H175.112L174.584 15.0483C173.992 12.8723 173.368 12.1683 171.768 12.1683H169.048V17.0003H167.88V5.80029H172.008C174.408 5.80029 175.96 7.12829 175.96 8.98429C175.96 10.3603 175.064 11.2883 173.576 11.7043C174.728 12.1683 175.272 13.1923 175.672 14.6803ZM169.048 6.82429V11.1443H171.832C173.56 11.1443 174.744 10.3923 174.744 8.98429C174.744 7.60829 173.624 6.82429 171.992 6.82429H169.048Z",
    fill: "#101828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.467 5.38452C134.799 5.38452 130.203 9.98014 130.203 15.6488C130.203 21.3175 134.799 25.9132 140.467 25.9132C146.136 25.9132 150.732 21.3175 150.732 15.6488C150.732 9.98014 146.136 5.38452 140.467 5.38452ZM146.419 17.041H142.558C142.173 17.041 141.86 17.3541 141.86 17.739V21.6001H139.074V17.739C139.074 17.3541 138.761 17.041 138.376 17.041H134.515V14.2554H138.376C138.761 14.2554 139.074 13.9424 139.074 13.5575V9.69634H141.86V13.5575C141.86 13.9424 142.171 14.2554 142.558 14.2554H146.419V17.041Z",
    fill: "#6BE4FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M138.377 17.0412H134.516V14.2556C130.893 14.2556 130.633 18.5918 130.633 18.5918C132.755 25.2605 139.076 25.8183 139.076 25.8183V17.7392C139.076 17.3543 138.763 17.0412 138.378 17.0412H138.377Z",
    fill: "url(#paint0_linear_29156_25732)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M138.376 14.2566C138.761 14.2566 139.074 13.9436 139.074 13.5587V9.69752H141.86C141.86 6.07511 137.523 5.81445 137.523 5.81445C130.855 7.93626 130.297 14.2578 130.297 14.2578H138.376V14.2566Z",
    fill: "url(#paint1_linear_29156_25732)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.861 5.47827V9.6963V13.5574C141.861 13.9423 142.172 14.2554 142.559 14.2554H146.42V17.041C150.042 17.041 150.303 12.7048 150.303 12.7048C148.181 6.03613 141.859 5.47827 141.859 5.47827H141.861Z",
    fill: "url(#paint2_linear_29156_25732)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.415 17.0408H142.554C142.169 17.0408 141.856 17.3538 141.856 17.7387V21.5998H139.07C139.07 25.2223 143.406 25.4829 143.406 25.4829C150.075 23.3611 150.633 17.0396 150.633 17.0396H146.415V17.0408Z",
    fill: "url(#paint3_linear_29156_25732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29156_25732",
    x1: 134.854,
    y1: 14.2556,
    x2: 134.854,
    y2: 25.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29156_25732",
    x1: 141.86,
    y1: 10.0349,
    x2: 130.297,
    y2: 10.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29156_25732",
    x1: 146.082,
    y1: 17.041,
    x2: 146.082,
    y2: 5.47827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29156_25732",
    x1: 139.07,
    y1: 21.2625,
    x2: 150.633,
    y2: 21.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.32068cc6a3e99d097be3516add88d9ac.svg";
export { ForwardRef as ReactComponent };